import type { Path } from 'react-router';
import {
  // This is the only place where we should be using matchPath
  // oxlint-disable-next-line no-restricted-imports
  matchPath,
  resolvePath,
} from 'react-router';
import type { AppRoute } from '@gonfalon/router/generated/routeInfo';

export function matchAppRoute(pattern: AppRoute, path: Path) {
  return matchPath(pattern, resolvePath(path).pathname);
}
